

<h2 class="dialog-title">{{'meli.item.linkVariationsTitle'|translateTA}}</h2>

<div class="content">
    <div class="detail">
        <div class="detail-item" *ngFor="let meli of melidata">
            <meli-product-relation [melidata]="meli" [variation]="variation"></meli-product-relation>
        </div>
    </div>

</div>
<div class="finish">
    <button nz-button nzType="primary" (click)="finalizar($event)" cdkFocusInitial>{{'meli.item.finish'|translateTA}}</button>
    <span class="span10"></span>
    <button nz-button nzDanger [mat-dialog-close]="false">{{'meli.item.cancel'|translateTA}}</button>
</div>
